module.exports = __webpack_public_path__ + "img/page-box-4.34ec855.jpg";